// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2k7ql","signatureBlock":"Footer_signatureBlock__1KpDz","signature":"Footer_signature__LSwMC"};